/**
 * хелпер проверяет, является ли прикрепленный аттачмент файлом на клиенте, т.е его еще не отправили на сервер
 * и соответственно файлом со структурой TAttachmentOnClient
 * @param obj - принимает структуру аттачмента
 */
import { TAttachmentOnClient } from '@entities/attachment/model/types';

export function isClientAttachment(obj: unknown): obj is TAttachmentOnClient {
    return !!obj && typeof obj === 'object' && 'file' in obj;
}
